import { render, staticRenderFns } from "./VentureHireService.vue?vue&type=template&id=348e057c"
import script from "./VentureHireService.vue?vue&type=script&lang=js"
export * from "./VentureHireService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports